import { render } from "./Cabecalho.vue?vue&type=template&id=af839412"
import script from "./Cabecalho.vue?vue&type=script&lang=js"
export * from "./Cabecalho.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__